import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { addDaysToDate, formatDate, formatMoney, getCurrentDateForInput, getInlineLoader, remove255 } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_AVAILABLE_ROOMS,
	STR_BOOK_NOW,
	STR_BOOK_THIS_ROOM,
	STR_CHANGE_PHONE_NUMBER,
	STR_CHECK_IN_DATE,
	STR_CHECK_OUT_DATE,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_ENTER_PHONE_NUMBER_FOR_PAYMENT,
	STR_FINALIZE_PAYMENT_CARD,
	STR_FINALIZE_PAYMENT_MOBILE,
	STR_GO_BACK,
	STR_INVALID_CHECK_IN_DATE,
	STR_INVALID_NUMBER_OF_DAYS,
	STR_INVALID_PAYWITH,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_NUMBER_OF_DAYS,
	STR_OVERALL_COST,
	STR_PAY_WITH_CARD,
	STR_PAY_WITH_MOBILE,
	STR_PAYMENT_SETTINGS,
	STR_PER_DAY,
	STR_PERSONAL_SETTINGS,
	STR_ROOM,
	STR_STARTING_FROM_DATE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TOTAL_ORDER_PRICE,
	STR_TRANSACTION_FEEs,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_DAYS,
	STR_DAY,
	STR_BOOKING_DATE,
	STR_VIEW_HOTEL,
	STR_VIEW_ROOM,
	STR_NO_PERMISSION,
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdArrowRight, MdCheckCircle, MdContactPage, MdHotel, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdRoom, MdSupportAgent, MdTranslate, MdWarning } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneRoomOrder from '../ones/OneRoomOrder';
import ImagesSlider from "../ones/ImagesSlider";
import { CDN_URL, callApi } from "../Helpers";
import MobileInterface from "../MobileInterface";
import { TbBrandDaysCounter } from "react-icons/tb";
import RoomOrderReceipt from "../ones/RoomOrderReceipt";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState(null);
	const [hotelData, setHotelData] = useState(null);
	
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
		]);
		setReady(true);
	}


	async function getData() {
		await callApi('get-hotel-room-data', { id }).then(async (response) => {
			if(response.status === 1) {
				setData(response.data)
				await Promise.all([
					getHotelData(response.data.hotelId),
				]);
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	
	async function getHotelData(hotelId) {
		await callApi('get-hotel-data', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function makeRoomAvailable(status) {
		setLoading(true)
		await callApi('make-hotel-room-available', { id }).then((response) => {
			if(response.status === 1) {
				getData();
				appContext.tellMessage('Successful')
			} else {
				appContext.tellError(response.msg)
			}
		})
		setLoading(false);
	}

	async function makeRoomUnavailable(status) {
		setLoading(true);
		await callApi('make-hotel-room-unavailable', { id }).then((response) => {
			if(response.status === 1) {
				getData();
				appContext.tellMessage('Successful')
			} else {
				appContext.tellError(response.msg)
			}
		})
		setLoading(false);
	}

	async function checkOutCurrentGuest(status) {
		setLoading(true)
		await callApi('checkout-current-guest', { id }).then((response) => {
			if(response.status === 1) {
				getData();
				appContext.tellMessage('Successful')
			} else {
				appContext.tellError(response.msg)
			}
		})
		setLoading(false);
	}

	function getAttributeName(_id) {
		let name = '';
		if(appContext.allRoomAttributes) {
			for (const _attribute of appContext.allRoomAttributes) {
				if(Number(_attribute.id) === Number(_id)) {
					name = _attribute.nameEn + ' - ' + _attribute.nameSw;
					break;
				}
			}
		}

		return name;
	}
	
	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && data && hotelData) {
		return (	
			<div className="container">	

				<div className="row">
				
					{
						(Number(appContext.currentUserData.id) === Number(hotelData.managerId)) ?
						<>
						
							<div className="col-md-12 mt-3 mb-3">
								<div className="card">
									<div className="card-body">
										<h6 className="card-title">Room Details</h6>
										<hr/>

										<div className="row">

											<div className="col-12 col-md-6 mt-2 mb-2">
												<label className="form-label">Name</label>
												<h6
												>
													{data.name}
												</h6>
											</div>


											<div className="col-12 col-md-12 mt-2 mb-2">
												<label className="form-label">Description</label>
												<h6
												>
													{data.description || "N/A"}
												</h6>
											</div>

											<div className="col-12 col-md-12 mt-2 mb-2">
												<label className="form-label">Features</label>
												{
													(JSON.parse(data.features).length > 0) ?
													(JSON.parse(data.features).map((item, i) => {
														return (
															<h6
																style={{
																	fontSize: "18px"
																}}
																className="font-regular"
																key={i}
															>
																<MdArrowRight size={18}/>
																{getAttributeName(item)}
															</h6>
														)
													}))
													:
													<h6>No features were found</h6>
												}
											</div>

											{
												(data.photo1) ?
												<div className="col-6 col-md-4 mt-2 mb-2">
													<img
														src={CDN_URL+data.photo1}
														style={{
															width: "100%"
														}}
													/>
												</div>
												:""
											}

											{
												(data.photo2) ?
												<div className="col-6 col-md-4 mt-2 mb-2">
													<img
														src={CDN_URL+data.photo2}
														style={{
															width: "100%"
														}}
													/>
												</div>
												:""
											}

											{
												(data.photo3) ?
												<div className="col-6 col-md-4 mt-2 mb-2">
													<img
														src={CDN_URL+data.photo3}
														style={{
															width: "100%"
														}}
													/>
												</div>
												:""
											}

											{
												(data.photo4) ?
												<div className="col-6 col-md-4 mt-2 mb-2">
													<img
														src={CDN_URL+data.photo4}
														style={{
															width: "100%"
														}}
													/>
												</div>
												:""
											}

											{
												(data.photo5) ?
												<div className="col-6 col-md-4 mt-2 mb-2">
													<img
														src={CDN_URL+data.photo5}
														style={{
															width: "100%"
														}}
													/>
												</div>
												:""
											}

											<div className="col-12">
												<hr/>
											</div>

											<div className="col-12 col-md-6 mt-2 mb-2">
												<label className="form-label">Is Booked</label>
												<h6
												>
													{data.isBooked}
												</h6>
											</div>

											<div className="col-12 col-md-6 mt-2 mb-2">
												<label className="form-label">Is Available</label>
												<h6
												>
													{data.isAvailable}
												</h6>
											</div>

											<div className="col-12">
												<hr/>
											</div>

											<div className="col-6 col-md-6 mt-2 mb-2">
												<label className="form-label">Current Guest CheckInDate</label>
												<h6
												>
													{data.currentBookerCheckInDate || 'N/A'}
												</h6>
											</div>

											<div className="col-6 col-md-6 mt-2 mb-2">
												<label className="form-label">Current Guest CheckOutDate</label>
												<h6
												>
													{data.currentBookerCheckOutDate || 'N/A'}
												</h6>
											</div>
											

										</div>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-1 mb-1">
								<div className="card">
									<div className="card-body">
										<h6 className="card-title">Actions</h6>
										<hr/>

										

										{
											(data.isAvailable === 'yes' && data.isBooked === 'no') ?
											<button
												className="btn btn-outline-dark m-1 btn-sm btn-rounded btn-padded"
												onClick={() => {
													makeRoomUnavailable()
												}}
											>
												Make This Room Unavailable
											</button>
											:""
										}

										{
											(data.isAvailable === 'no' && data.isBooked === 'no') ?
											<button
												className="btn btn-outline-dark m-1 btn-sm btn-rounded btn-padded"
												onClick={() => {
													makeRoomAvailable()
												}}
											>
												Make This Room Available
											</button>
											:""
										}
										
										{
											(data.isAvailable === 'no' && data.isBooked === 'yes' && data.currentBookerId) ?
											<button
												className="btn btn-danger m-1 btn-sm btn-rounded btn-padded"
												onClick={() => {
													appContext.activateDialog({
														message: "Manually check out current guest?",
														onConfirm: checkOutCurrentGuest,
													})
												}}
											>
												Check Out Current Guest
											</button>
											:""
										}
										
									</div>
								</div>
							</div>
						
						</>
						:
						<div className="col-md-12">
							<div className="card">
								<div className="card-body text-center">
									<MdWarning size={56} className="text-secondary"/>

									<h6
										style={{
											fontSize: "22px"
										}}
										className="font-semi-bold"
									>
										{STR_NO_PERMISSION[appContext.language]}
									</h6>
								</div>
							</div>
						</div>
					}
					
				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}